import { makeStyles } from "@material-ui/core";
import heroBackground from "../assets/palazzo3.jpg";

export const useHomeStyles = makeStyles((theme) => ({
    "@global": {
        body: {
        backgroundColor: "#fff",
        margin: 0,
        },
        a: {
        textDecoration: 'none',
        color: '#9334ff',
        cursor: 'hand'
        }
    },
    root: {
        flexGrow: 1,
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: 200,
            color: '#000',
            '& .MuiFormLabel-root': {
                color: '#000',
                '&.Mui-error': {
                color: '#f44336',
                }
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#000',
            },
            '& .MuiInput-underline:before': {
                borderBottomColor: '#000',
            },        
            '& .MuiInputBase-input': {
                color: '#000',
            },
            '& .Mui-error': {
                color: '#f44336',
                '& .MuiInputBase-input': {
                color: '#f44336',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#f44336',
                
                },
            },
        },
        '& .MuiButton-contained.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.3)',
            backgroundColor: 'rgba(0, 0, 0, 0.12)'
        },
        '& .MuiFormHelperText-root': {
            color: '#f44336'
        }
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        fontWeight: 'bold',
    },
    hero: {
        minHeight: '70vh',
        backgroundImage: `url(${heroBackground})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '0',
        padding: 10,
    },
    paper: {
        background: 'transparent',
    },
    list: {
        lineHeight: '1.5',
        margin: 0,
        color: '#8c8c8c',
        '& li': {
        padding: '0 0 20px',
        },
    },
    innerList: {
        padding: '10px 24px',
        // '& li': {
        
        // },
        '& li:last-child': {
        padding: 0,
        }
    },
    bodyPaper: {
        color: '#000',
        background: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    card: {
        maxWidth: 345,
        margin: '0 18px',
        backgroundColor: '#fff',
        display: 'flex',
        flexFlow: 'column nowrap',
        justifyContent: 'space-between'
    },
    accordionHeading: {

    },
    footer: {
        backgroundColor: '#232323'
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
        display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
        display: 'none',
        },
    },
    perksContainer: {
        [theme.breakpoints.down('sm')]: {
        flexDirection: 'column-reverse'
        },
    },
    recruitNowButton: {

        [theme.breakpoints.up('md')]: {
        display: 'none',
        },
    },
    rewardsBox: {
        display: 'flex', 
        alignItems: 'center', 
        background: 'white', 
        boxShadow: '0px 0px 5px 1px rgb(0 0 0 / 20%)', 
        minHeight: '100px',
        cursor: 'pointer'
    },
    modalPaper: {
        position: 'absolute',
        width: '90%',
        backgroundColor: '#fff', //theme.palette.background.paper,
        border: '1px solid #000',
        borderRadius: '5px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 4),
        [theme.breakpoints.up('md')]: {
        width: '500px'
        },
    },
}));